import React from "react";
import { MainModal } from "../../../../components/modal/MainModal";

export const Delete = ({ onClose, primaryBtnHandler, children }) => {
  return (
    <MainModal
      parentSelector=".referral-categories"
      isOpen
      onClose={onClose}
      headerText="Delete"
      headerCloseHandler={onClose}
      width={400}
      height="auto"
      primaryButtonText="Delete"
      primaryBtnHandler={primaryBtnHandler}
      primaryButtonClass="critical"
      secondaryBtnText="Cancel"
      secondaryBtnHandler={onClose}
      containerClassName="dialog"
    >
      {children}
    </MainModal>
  );
};
